import { useState } from 'react'
import type { ReactNode } from 'react'
import { View } from 'react-native'

interface StampGridProps {
  count: number
  stampSize: number
  renderStamp: (index: number) => ReactNode
  gap?: number
  maxGap?: number
  justify?: 'flex-start' | 'center'
}

export function StampGrid({ count, stampSize, renderStamp, gap = 16, maxGap = 32, justify = 'flex-start' }: StampGridProps) {
  const [containerWidth, setContainerWidth] = useState(0)

  const perRowCapacity =
    containerWidth === 0
      ? Math.max(count, 1)
      : Math.max(1, Math.floor((containerWidth + gap) / (stampSize + gap)))
  const rowCount = Math.max(1, Math.ceil(count / perRowCapacity))
  const baseRowLength = Math.floor(count / rowCount)
  const extraRows = count % rowCount

  let cursor = 0
  const rows = Array.from({ length: rowCount }, (_, r) => {
    const length = baseRowLength + (r < extraRows ? 1 : 0)
    const start = cursor
    cursor += length
    return { start, length }
  })

  return (
    <View onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)} className="gap-4">
      {rows.map(({ start, length }, r) => {
        const stretchedGap = length > 1 ? (containerWidth - length * stampSize) / (length - 1) : maxGap
        const rowGap = containerWidth === 0 ? gap : Math.max(gap, Math.min(stretchedGap, maxGap))
        return (
          <View key={r} className="flex-row" style={{ gap: rowGap, justifyContent: justify }}>
            {Array.from({ length }, (_, i) => renderStamp(start + i))}
          </View>
        )
      })}
    </View>
  )
}